import TopNavbarTemplate from './TopNavbarTemplate';
import styled, { breakpoints } from '../../styles/theme';
import { rem } from 'polished';
import BP from '../../constants/breakpoints';

export const TopNavbarStyled = styled(TopNavbarTemplate)`
    background: ${(p) => p.theme.colors.white};
    display: flex;
    align-items: center;
    padding: 0.8rem;
    border-bottom: 0.05rem solid ${(p) => p.theme.colors.champagne3};

    .topnavbar-grid {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 3fr 1fr;
        align-items: center;
    }

    .topnavbar-returnlink__hidden {
        visibility: hidden;
    }

    .topnavbar-returnlink {
        cursor: pointer;
        color: ${(p) => p.theme.colors.black};
        text-transform: uppercase;
        font-size: ${(p) => p.theme.fontSizes.h5};
        padding: 0.6rem 1rem 0.8rem;
        transition: all 0.15s ease-out;
        transform: scale(0.8);
        margin-left: -10px;
        display: flex;
        align-items: baseline;
        white-space: nowrap;
        width: 6.5rem;
        background: none;

        @media (min-width: ${breakpoints.xs}px) {
            transform: scale(1);
            margin-left: 0;
        }

        > div {
            height: unset;
        }

        &.isDisabled {
            cursor: default;
            opacity: 0.5;
        }

        &:not(.isDisabled) {
            :hover,
            :focus-visible {
                background-color: ${(p) => p.theme.colors.primary};
                border-color: ${(p) => p.theme.colors.primary};
                color: ${(p) => p.theme.colors.white};
                svg {
                    path {
                        stroke: ${(p) => p.theme.colors.white};
                    }
                }
            }
        }
    }

    .content {
        display: flex;
        position: relative;
        justify-content: center;
        font-size: ${rem('18px')};

        @media (min-width: ${breakpoints.sm}px) {
            font-size: ${rem('20px')};
        }

        @media (min-width: ${breakpoints.md}px) {
            font-size: ${rem('24px')};
        }

        &-title {
            line-height: 1.33;
            position: relative;
            top: 2px;
            text-align: center;
            text-transform: uppercase;
            font-weight: ${({ theme }) => theme.fontWeights.textMedium};
            font-size: ${({ theme }) => theme.fontSizes.textMedium};

            @media (min-width: ${breakpoints.md}px) {
                font-size: ${({ theme }) => theme.fontSizes.textBig};
            }
        }

        &-step {
            &::after {
                content: '|';
                margin: 0 0.5rem;
                font-weight: ${({ theme }) => theme.fontWeights.textMedium};
            }
        }
    }

    .save-button {
        padding: 0.805rem 1rem;
        border: 1px solid ${({ theme }) => theme.colors.grey4};
        font-size: ${(p) => p.theme.fontSizes.h5};
        background: ${({ theme }) => theme.colors.white};
        transition: all 0.15s ease-out;
        text-transform: uppercase;
        margin-left: auto;

        :enabled {
            cursor: pointer;
        }

        :hover:enabled,
        :focus-visible:enabled {
            border-color: ${(p) => p.theme.colors.primary};
            background: ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.white};
        }

        @media (max-width: ${BP.MOBILE}) {
            display: none;
        }
    }

    svg {
        transform: rotate(-90deg);
        height: 0.75rem;
        width: 0.75rem;
        margin: 0.3rem 0.5rem 0 0;
        path {
            transition: all 0.15s ease-out;
            stroke: ${(p) => p.theme.colors.primary};
            stroke-width: 0.2rem;
        }
    }

    .selectContainer {
        max-width: 0;
        padding-right: 0;
        position: unset;
    }

    .Select {
        &__value-container {
            display: none;
        }

        &__control {
            min-height: 0px;
            position: unset;
            background-color: transparent;
        }

        &__menu {
            z-index: 6;
            min-width: 9rem;
            left: 50%;
            margin-left: -4.5rem;
        }
    }
`;
